import type { CustomerDomain, Substrate, PdfTemplate } from '../../../BackEndTypes';
import type { ColorCardError, ColorCardState } from '../../store/store';
import * as types from './types';

const initialState: ColorCardState = {
    domain: undefined,
    substrates: [],
    templates: [],
    error: null,
    isSubmitting: false,
};

type ColorCardAction =
    | { type: typeof types.GET_CUSTOMER_DOMAINS_SUCCESS; payload: CustomerDomain }
    | { type: typeof types.GET_CUSTOMER_DOMAINS_FAILURE; error: ColorCardError }
    | { type: typeof types.LIST_SUBSTRATES_SUCCESS; payload: Substrate[] }
    | { type: typeof types.LIST_SUBSTRATES_FAILURE; error: ColorCardError }
    | { type: typeof types.LIST_TEMPLATES_SUCCESS; payload: PdfTemplate[] }
    | { type: typeof types.LIST_TEMPLATES_FAILURE; error: ColorCardError }
    | { type: typeof types.SUBMIT_START }
    | { type: typeof types.SUBMIT_ACCEPTED }
    | { type: typeof types.SUBMIT_START_FAILURE; error: ColorCardError }
    | { type: typeof types.SUBMIT_SUCCESS }
    | { type: typeof types.SUBMIT_FAILURE; error: ColorCardError }
    | { type: typeof types.CLEAR_ERROR };

// Limitation: ColorCard currently supports one active error banner. When
// requests fail concurrently, the latest failure replaces the previous error.
export default function colorCard(state: ColorCardState = initialState, action: ColorCardAction): ColorCardState {
    switch (action.type) {

        case types.GET_CUSTOMER_DOMAINS_SUCCESS:
            return { ...state, domain: action.payload };

        case types.GET_CUSTOMER_DOMAINS_FAILURE:
            return { ...state, error: action.error };

        case types.LIST_SUBSTRATES_SUCCESS:
            return { ...state, substrates: action.payload };

        case types.LIST_SUBSTRATES_FAILURE:
            return { ...state, error: action.error };

        case types.LIST_TEMPLATES_SUCCESS:
            return { ...state, templates: action.payload };

        case types.LIST_TEMPLATES_FAILURE:
            return { ...state, error: action.error };

        case types.SUBMIT_START:
            return { ...state, isSubmitting: true, error: null };

        case types.SUBMIT_ACCEPTED:
            return { ...state, isSubmitting: false };

        case types.SUBMIT_START_FAILURE:
            return { ...state, isSubmitting: false, error: action.error };

        case types.SUBMIT_SUCCESS:
            return state;

        case types.SUBMIT_FAILURE:
            return { ...state, error: action.error };

        case types.CLEAR_ERROR:
            return { ...state, error: null };

        default:
            return state;
    }
}
